import type { RouteObject } from 'react-router';

import type { RouteHandle } from '@/hooks/useRouteHandle';

const page = (name: string) => () =>
  import(`./pages/${name}.tsx`).then((m) => ({ Component: m[name] }));

/** 기업 회원 홈·우리 회사·온보딩(specs/065) — 기능 키 COMPANY_HOME(기업 축만 허용). */
export const myCompanyRoutes: RouteObject[] = [
  {
    path: 'home',
    lazy: page('MyCompanyHomePage'),
    handle: { title: '홈', yearIndependent: true, feature: 'COMPANY_HOME' } satisfies RouteHandle,
  },
  {
    path: 'my-company',
    lazy: page('MyCompanyPage'),
    handle: {
      title: '우리 회사',
      yearIndependent: true,
      feature: 'COMPANY_HOME',
    } satisfies RouteHandle,
  },
  {
    path: 'my-company/onboarding',
    lazy: page('MyCompanyOnboardingPage'),
    handle: {
      title: '회사 정보 넣기',
      yearIndependent: true,
      feature: 'COMPANY_HOME',
    } satisfies RouteHandle,
  },
];
